import React from 'react';

import LoadingIndicator from './loadingIndicator';

const staticIndicator = (
  <LoadingIndicator global={true}>{'Loading...'}</LoadingIndicator>
);

export default staticIndicator;
